// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__hoSl6","text":"SelectPayment_text__3BNf4","title":"SelectPayment_title__392t6","btn":"SelectPayment_btn__1TTqX"};